"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrophoneMuted = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var react_1 = tslib_1.__importDefault(require("react"));

var MicrophoneMuted = function MicrophoneMuted() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.002 9.143V4.57A4.571 4.571 0 0011.43 0 4.571 4.571 0 007.18 2.937l8.309 8.309c.34-.649.516-1.37.514-2.103zm5.543 11.794l-.606.606a.549.549 0 01-.8 0l-4.377-4.4a8.94 8.94 0 01-3.189 1.028v2.4h1.714c.316 0 .572.256.572.572v1.143a.571.571 0 01-.572.571H8.573a.571.571 0 01-.571-.571v-1.143c0-.316.256-.572.571-.572h1.714v-2.365a9.211 9.211 0 01-6.857-4.652.64.64 0 010-.457.606.606 0 01.309-.343l1.028-.48a.56.56 0 01.743.229 6.857 6.857 0 008.595 2.96l-1.829-1.829a4.571 4.571 0 01-5.417-4.491v-.869L1.316 2.72a.549.549 0 010-.8l.606-.606a.549.549 0 01.8 0l18.823 18.823a.549.549 0 010 .8zm-2.115-7.84a.64.64 0 010 .457c-.207.348-.44.68-.697.995L17.1 12.914c.091-.137.171-.274.251-.411a.56.56 0 01.743-.229l1.029.48c.144.07.255.193.308.343z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    stroke: ui_symbols_1.COLOR.RED[500],
    d: "M23.477 22.775l.005.006.006.005a.048.048 0 01.015.035.049.049 0 01-.015.036l-.006.005-.005.006-.606.605-.005.006-.006.006a.048.048 0 01-.035.015.05.05 0 01-.036-.015l-.006-.006-.005-.006-3.76-3.748h0L6.56 7.27h0L.527 1.225.521 1.22l-.006-.006a.048.048 0 010-.07l.006-.006.006-.006.605-.605.006-.006.005-.006a.049.049 0 01.071 0l.006.006.005.006 22.252 22.248z"
  }));
};

exports.MicrophoneMuted = MicrophoneMuted;